import { Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;

  handleOpenEditBlacklistNameDialog(): void;

  handleOpenDeleteBlacklistDialog(): void;

  handleCloseMenu(): void;
}

const BlacklistItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  handleOpenEditBlacklistNameDialog,
  handleOpenDeleteBlacklistDialog,
  handleCloseMenu,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenEditBlacklistNameDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('editBlacklistName')}</Typography>
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenDeleteBlacklistDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={cx(classes.menuItemText, 'delete')}>{t('delete')}</Typography>
      </MenuItem>
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '8px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.backgrounds.main,
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default BlacklistItemMenu;
